<fcom-flight-summary [items]="items()" (clicked)="clickedBound.emit($event)" />
